export type ProductsDataTabMessages = {
  productCodeLabel: string;
  productNameLabel: string;
  productDescriptionLabel: string;
  productQuantityLabel: string;
  stockColumnLabel: string;
  promotionalPriceLabel: string;
  optionsColumn: string;

  errorRequiredProductCode: string;
  errorRequiredProductName: string;
  errorRequiredProductDescription: string;
  errorRequiredProductQuantity: string;
  errorRequiredPromotionalPrice: string;

  productAlreadyAdded: string;
  productNotFound: string;

  fullDescriptionLabel: string;
  tooltipViewMore: string;
  invalidQuantityError: string;
  invalidPriceError: string;
};

export const PRODUCTS_DATA_TAB_MESSAGES: ProductsDataTabMessages = {
  // Labels
  productCodeLabel: "Código",
  productNameLabel: "Nome",
  productDescriptionLabel: "Descrição",
  productQuantityLabel: "Quantidade mínima",
  stockColumnLabel: "Estoque",
  promotionalPriceLabel: "Preço Promocional",
  optionsColumn: "Opções",

  // Error messages
  errorRequiredProductCode: "O código é obrigatório!",
  errorRequiredProductName: "O nome é obrigatório!",
  errorRequiredProductDescription: "A descrição é obrigatória!",
  errorRequiredProductQuantity: "A quantidade é obrigatória!",
  errorRequiredPromotionalPrice: "O preço promocional é obrigatório!",

  productAlreadyAdded: "O produto já foi adicionado!",
  productNotFound: "Produto não encontrado",

  fullDescriptionLabel: "Descrição Completa",
  tooltipViewMore: "Clique para ver mais",
  invalidQuantityError: "O valor não pode ser 0 ou inválido.",
  invalidPriceError: "O valor não pode ser 0 ou inválido.",
};
